import { createFileRoute, Outlet, useRouter } from '@tanstack/react-router';
import { Loader } from 'lucide-react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { toast } from 'sonner';
import { CaseContextProvider } from '@/components/providers/case-context-provider';
import { EditorContextProvider } from '@/components/providers/editor-context-provider';
import { FileProcessingContextProvider } from '@/components/providers/file-processing-context-provider';
import { MessageContextProvider } from '@/components/providers/message-context-provider';
import { isServerSideEnabled } from '@/lib/file/common';
import { auth, FIREBASE_TENANT_ID_LOCAL_STORAGE_KEY } from '@/lib/firebase/client';

export const Route = createFileRoute('/(main)/_mainLayout')({
  component: MainLayout,
});

function MainLayout() {
  const [user, loading] = useAuthState(auth);
  const router = useRouter();

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader color="#385af5" />
      </div>
    );
  }

  if (!user) {
    router.navigate({ to: '/login' });
  }

  if (
    localStorage.getItem(FIREBASE_TENANT_ID_LOCAL_STORAGE_KEY) === null &&
    isServerSideEnabled()
  ) {
    toast.error('Gebruiker heeft geen tenant-id. Uitloggen.', {
      position: 'bottom-right',
    });
    router.navigate({ to: '/login' });
  }

  return (
    <CaseContextProvider>
      <MessageContextProvider>
        <EditorContextProvider>
          <FileProcessingContextProvider>
            <Outlet />
          </FileProcessingContextProvider>
        </EditorContextProvider>
      </MessageContextProvider>
    </CaseContextProvider>
  );
}
